import { connect } from 'react-redux';
import PrintCommercialEstimate from './PrintCommercialEstimate';
import { getItemsForEstimate } from '../../selectors/getItemsForEstimate';

const mapStateToProps = ({ estimateBuilder }) => {
  const { entities, uiState } = estimateBuilder;
  const itemsWithProductCount = getItemsForEstimate(entities, uiState.selectedEstimate).reduce(
    (acc, item) => (item.itemProduct ? acc + 1 : acc),
    0,
  );

  return {
    designId: estimateBuilder.uiState.selectedEstimate,
    hasProducts: itemsWithProductCount > 0,
  };
};


export default connect(mapStateToProps)(PrintCommercialEstimate);
